<script>
import { srcset } from "@/common/responsive-helpers";

export default {
  name: "ImageResponsive",
  props: {
    src: {
      type: [String, Array],
      required: true
    },
    width: {
      type: String,
      default: undefined
    },
    height: {
      type: String,
      default: undefined
    },
    alt: {
      type: String,
      default: undefined
    },
    presentational: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    imgClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    srcset() {
      if (Array.isArray(this.src)) {
        let set = "";

        this.src.forEach((src, index) => {
          set += `${src} ${index + 1}x, `;
        });

        return set;
      }

      return srcset(this.src);
    },
    loadingMode() {
      return this.lazy ? "lazy" : undefined;
    },
    imgAlt() {
      if (this.presentational) {
        // A purely presentational image has an empty alt
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img
        return "";
      }

      return this.alt;
    },
    imgRole() {
      if (this.presentational) {
        return "presentation";
      }

      return null;
    }
  }
};
</script>

<template>
  <picture>
    <slot>
      <img
        :class="['image-responsive', imgClass]"
        :src="src"
        :srcset="srcset"
        :alt="imgAlt"
        :width="width"
        :height="height"
        :loading="loadingMode"
        :role="imgRole"
      />
    </slot>
  </picture>
</template>
